import { api } from "./api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const exchangeSessionId = async (sessionId) => {
  const { data } = await api.post(
    `/auth/session`,
    {},
    { headers: { "X-Session-ID": sessionId } }
  );
  return data;
};

export const fetchMe = async () => {
  const { data } = await api.get(`/auth/me`);
  return data;
};

export const logout = async () => {
  await api.post(`/auth/logout`);
};

export const listFavorites = async () => {
  const { data } = await api.get(`/favorites`);
  return data;
};

export const addFavorite = async (payload) => {
  const { data } = await api.post(`/favorites`, payload);
  return data;
};

export const deleteFavorite = async (id) => {
  const { data } = await api.delete(`/favorites/${id}`);
  return data;
};

export const publicHistory = async (limit = 6) => {
  const { data } = await api.get(`/history`, { params: { limit } });
  return data.items || [];
};

export const myHistory = async (limit = 20) => {
  const { data } = await api.get(`/history/me`, { params: { limit } });
  return data.items || [];
};
